<template>
  <div class="auth-process-container" id="login-process-container">
    <div class="auth-process" id="login-process">
      <q-card bordered flat class="auth-process-card" id="login-process-card">
        <img alt="" :src="require('../assets/brands/logo.png')"/>
        <q-card class="flexbox">
          <div class="profile-content flex">
            <p class="full-width text-center">Authorizing your account...</p>
            <loading v-if="isLoading" id="loading"></loading>
          </div>
        </q-card>
      </q-card>
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import Loading from "@/components/Loading.vue";

export default {
  name: "oauth2-redirect",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: true,
      user: null
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.profile.user
      },
      set(val) {
        this.$store.commit('profile/SET_USER', val)
      }
    }
  },
  async mounted() {
    try {
      const {data: meData} = await axios.get('/me');
      this.user = meData.data;
    } catch (error) {
      console.error(error);
    }

    try {
      const {data} = await axios.get(`/auth/oauth2/${this.$route.params.provider}/redirect`, {
        params: {...this.$route.query, user_id: this.user?.id}
      });
      localStorage.setItem('token', `Bearer ${data.data.token}`)
      localStorage.setItem('refresh_token', `Bearer ${data.data.refresh_token}`)
      this.$router.push(data.data.redirect_path);
      window.location.reload();
    } catch (error) {
      console.error(error);
      this.$q.notify({
        message: 'An error occurred while processing your request.',
        timeout: 2000,
        position: 'top-right',
        progress: true,
        type: 'negative'
      })
      this.$router.push('/');
    } finally {
      this.isLoading = false;
    }
  },
  methods: {},
  metaInfo() {
    return {
      title: `Social Account Login Redirect - FMS`,
      meta: [
        {
          name: "description",
          content: "",
        },
        {
          property: "og:title",
          content: "Social Account Login Redirect - FMS",
        },
        {property: "og:site_name", content: "FMS"},
        {property: "og:type", content: "website"},
        {name: "robots", content: "index,follow"},
      ],
    };
  },
};
</script>

<style scoped>
.special-component {
  width: 100%;
  background-color: #fff;
}

.item {
  padding: 10px;

  > div {
    padding: 10px 10px 30px;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }
}
</style>
